enum QuestionnaireState {
    WAITING_FOR_APPROVAL = 'waitingForApproval',
    PUBLISHED = 'published',
    DRAFT = 'draft',
}

export default QuestionnaireState;
